import { default as styled } from 'styled-components/macro'

export const DataTableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`
